export default __webpack_public_path__ + "static/media/v-logo.afc15396.png";